export const LOCALES = {
  'de-DE': 'German (Germany)',
  'en-US': 'English (United States)',
  'en-GB': 'English (United Kingdom)',
  'en-PL': 'English (Pseudolocalized/Debug)',
  'fr-FR': 'French (France)',
  'ja-JP': 'Japanese (Japan)',
} as const;

export const SUPPORTED_LOCALES = Object.keys(LOCALES) as Array<
  keyof typeof LOCALES
>;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE = 'en-US';
export const PSEUDO_LOCALE = 'en-PL';

export const LocalizationEnvs = ['test', 'production'] as const;
export type LocalizationEnv = (typeof LocalizationEnvs)[number];
export const DEFAULT_LOC_ENV = 'production';
